// extracted by mini-css-extract-plugin
export var body = "_ml-8";
export var button = "_ml-0";
export var closeButton = "_ml-5";
export var content = "_ml-3";
export var empty = "_ml-f";
export var grid = "_ml-c";
export var header = "_ml-4";
export var icon = "_ml-1";
export var option = "_ml-d";
export var optionSelected = "_ml-e";
export var overlay = "_ml-2";
export var searchIcon = "_ml-a";
export var searchInput = "_ml-b";
export var searchWrapper = "_ml-9";
export var title = "_ml-6";
export var visuallyHidden = "_ml-7";